export default "__VITE_ASSET__ySLnBMku__"